import React from 'react';
import { motion } from 'framer-motion';

export const Card = ({ children, className = '', hover = false, onClick, delay = 0 }) => {
  const baseStyle = "bg-white rounded-2xl border border-slate-200 shadow-[0_6px_20px_rgba(22,75,122,0.06)] overflow-hidden";
  const hoverStyle = hover ? "hover:shadow-md hover:border-indigo-200 transition-all cursor-pointer" : "";
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className={`${baseStyle} ${hoverStyle} ${className}`}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );
};

export const CardHeader = ({ title, subtitle, icon, action }) => (
  <div className="p-6 border-b border-slate-100 flex justify-between items-start">
    <div className="flex items-center gap-3">
      {icon && (
        <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">
          {icon}
        </div>
      )}
      <div>
        <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
    </div>
    {action && <div>{action}</div>}
  </div>
);

export const CardContent = ({ children, className = '' }) => (
  <div className={`p-6 ${className}`}>
    {children}
  </div>
);